<div class="flex flex-col gap-2">
  @if (fieldErrors().length > 0) {
    <div
      role="alert"
      data-testid="compatibility-field-errors"
      class="border-danger bg-danger-soft text-danger-hover flex flex-col gap-1 rounded-md border px-2 py-1.5 text-xs">
      <span class="font-semibold">{{ 'form.compatibility.save_refused' | translate }}</span>
      @for (message of fieldErrors(); track $index) {
        <span class="font-mono">{{ message }}</span>
      }
    </div>
  }

  @for (card of cards(); track $index; let i = $index) {
    <article
      data-testid="compatibility-requirement"
      class="bg-elevated flex flex-col gap-1 rounded-md border p-2 transition-colors"
      [class.border-default]="!card.editing"
      [class.border-accent-border]="card.editing"
      [attr.aria-label]="card.label">
      <div class="text-text-primary flex items-center gap-1.5 text-sm font-semibold">
        <i [class]="card.icon" aria-hidden="true" class="text-text-secondary"></i>
        <span>{{ card.label }}</span>
        @if (!card.phrase) {
          @if (card.penalty === null) {
            <span class="badge badge-neutral">{{
              'form.compatibility.hard' | translate
            }}</span>
          } @else {
            <span class="badge badge-pending">
              {{ 'form.compatibility.soft' | translate: { penalty: card.penalty } }}
            </span>
          }
        }
        <span class="flex-1"></span>
        @if (!isDisabled()) {
          @if (card.editable) {
            <button
              type="button"
              class="btn btn-icon"
              [attr.data-edit-index]="i"
              [attr.aria-label]="'form.compatibility.edit' | translate"
              (click)="edit(i)">
              <i [class]="ICONS.pencil" aria-hidden="true"></i>
            </button>
          }
          <button
            type="button"
            class="btn btn-icon hover:text-danger"
            [attr.aria-label]="'form.compatibility.remove' | translate"
            (click)="remove(i)">
            <i [class]="ICONS.trash" aria-hidden="true"></i>
          </button>
        }
      </div>
      @if (card.phrase; as phrase) {
        <app-path-filter-phrase [segments]="phrase" [label]="null" [framed]="false" />
      } @else {
        <app-dsl-text class="text-xs break-all" [text]="card.summary.filter" />
        @if (card.summary.when) {
          <app-dsl-text class="text-xs break-all" [text]="'when ' + card.summary.when" />
        }
      }
      @if (!card.editable) {
        <p class="form-help">{{ 'form.compatibility.target_unavailable' | translate }}</p>
      }
    </article>
  } @empty {
    <p class="text-text-tertiary text-xs">{{ 'form.compatibility.empty' | translate }}</p>
  }

  @if (!isDisabled() && addOptions().length > 0) {
    <button
      #addTrigger
      type="button"
      class="btn btn-transparent self-start"
      aria-haspopup="menu"
      [attr.aria-expanded]="addOpen()"
      (click)="addOpen.set(!addOpen())">
      <i [class]="ICONS.plus" aria-hidden="true"></i>
      {{ 'form.compatibility.add' | translate }}
    </button>
    <app-dropdown
      [target]="addTrigger"
      [template]="addMenu"
      [isOpen]="addOpen()"
      [onClose]="closeAdd"
      [useDefaultStyles]="false" />
  }
</div>

<ng-template #addMenu>
  <div class="g-menu" role="menu" appFocusFirst (keydown)="onAddMenuKey($event)">
    @for (option of addOptions(); track option.target) {
      <button
        type="button"
        role="menuitem"
        class="g-menu-item focus-visible:bg-interactive w-full outline-none"
        (click)="add(option.target)">
        <i [class]="option.icon" aria-hidden="true"></i>
        <span class="flex-1 text-left">{{ option.label }}</span>
      </button>
    }
  </div>
</ng-template>
